<template lang="pug">
  .alert(role='alert' :class="`alert-${alertType}`")
    .row
      .col-1(v-show="alertType === 'danger'")
        img.error-image(src='../assets/img/red_error_msg.svg' alt='Error Message' v-show="alertType === 'danger'")
      .col.super-grow
        .h7 {{ heading }}
        .message {{ message }}
      .col.my-auto(v-if="dismissable")
        .dismiss(:class="alertType")
          a(@click.prevent="$emit('dismiss')") DISMISS
</template>

<script>
export default {
  name: 'FormErrorAlert',
  props: {
    heading: {
      type: String,
      default: 'Error',
    },
    message: {
      type: String,
      default: 'An error was detected. Please try again later.',
    },
    alertType: {
      type: String,
      default: 'danger',
    },
    dismissable: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/bodies';
.h7 {
  color: #1e1432;
  margin-bottom: 0.5rem;
}

.message {
  @extend .body-3;
  color: #1e1432;
}

.dismiss {
  @extend .body-3;
  text-align: right;
  font-weight: bold;
}

.dismiss.danger {
  color: #a62226;
}

.dismiss.success {
  color: #006b09;
}

.dismiss:hover {
  text-decoration: underline;
  cursor: pointer;
}

.alert.alert-danger {
  background-color: #f8eeee;
  border: 1px solid #dbbfc1;
  // max-height: 5rem;
}

.error-image {
  height: 2rem;
}

.super-grow {
  flex-grow: 5;
}
</style>
